import { useCallback } from 'react';

import { getProducts } from '../api/Subscription';

import useWrappedApi from './useWrappedApi';

/**
 * Hook to fetch product/subscription options with retry capability.
 * @returns Object containing product data, error state, loading state, and retry function.
 */
const useProduct = () => {
  const fetchProducts = useCallback(() => getProducts(), []);
  const { isLoading, error, value, retry } = useWrappedApi(fetchProducts);

  return {
    product: value?.available_products[0],
    error,
    loading: isLoading,
    retry,
  };
};

export default useProduct;
